'use client';
import {SectionHeader} from '@/components/main/common';
import '/public/static/css/module/catch_list.scss';
import {isLogin} from '@/utils/main';
import CatchList from '../CatchList';
import useCatchList from '../../hooks/useCatchList';
import {getDomParser, getTextFromReactNode} from '@/utils/main/my-plus/section';

const CatchGroup = ({selectedMode, order}) => {
  const {catchList} = useCatchList(selectedMode);

  const headerText = (
    <>
      관심<span className='catch'>Catch</span> 모아보기
    </>
  );

  if (!catchList || catchList.length === 0) return null;

  return (
    <>
      <SectionHeader title={headerText} />
      <CatchList
        catchList={catchList}
        selectedMode={selectedMode}
        log={{
          path3: 'catch',
          sectionIdx: order,
          sectionTitle: getTextFromReactNode(headerText),
        }}
      />
    </>
  );
};
export default CatchGroup;
